import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["name", "hide"];

  displayNameInput() {
    this.hideTargets.forEach((element) => element.classList.add("d-none"));
    this.nameTarget.classList.remove("d-none");
  }
}
